// src/hocs/withLayout.js
import React from "react";
import { Grid } from "@mui/material";
import Topbar from "../scenes/global/Topbar";
import Sidebar from "../scenes/global/Sidebar";
import { DashboardNotificationsProvider } from "../context/DashboardNotificationsContext";
import NotificationBannerStack from "./DashboardNotifications/NotificationBannerStack";
import NotificationModal from "./DashboardNotifications/NotificationModal";
import NotificationToastContainer from "./DashboardNotifications/NotificationToastContainer";

const withLayout = (Component) => (props) =>
  (
    <DashboardNotificationsProvider>
      <Grid container sx={{ minHeight: "100vh" }}>
        <Grid item>
          <Sidebar />
        </Grid>
        <Grid item xs sx={{ minWidth: 0, maxWidth: "100%", overflowX: "hidden" }}>
          <Grid container direction="column" sx={{ minWidth: 0, maxWidth: "100%" }}>
            <Grid item>
              <Topbar />
            </Grid>
            <Grid item>
              <NotificationBannerStack />
            </Grid>
            <Grid item sx={{ minWidth: 0, maxWidth: "100%", overflowX: "hidden" }}>
              <Component {...props} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <NotificationModal />
      <NotificationToastContainer />
    </DashboardNotificationsProvider>
  );

export default withLayout;
